import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ForgotPasscode = ({ data }) => {
  let navigate = useNavigate();

  const [inputId, setInputId] = useState("");
  const [inputDob, setInputDob] = useState("");
  const [showPasscode, setShowPasscode] = useState(false);
  const [matchingId, setMatchingId] = useState(null);
  const [matchingDob, setMatchingDob] = useState(null);
  const handleInputId = (event) => {
    setInputId(event.target.value);
  };
  const handleInputDob = (event) => {
    setInputDob(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      const inputIdAsNumber = parseInt(inputId);
      const foundId = data.find((item) => item.t1key110 == inputIdAsNumber);
      setMatchingId(foundId);
      // const foundDob = data.find((item) => item.t1key170 == inputDob);
      // setMatchingDob(foundDob);
    };

    fetchData();
    return () => {
      setMatchingId(null);
      setMatchingDob(null);
    };
  }, [inputId, inputDob, data]);

  const handleShowPasscode = () => {

    if (matchingId && matchingId?.t1item170 === inputDob) {
      setShowPasscode(true);
    } else if (matchingId && matchingId?.t1item170 !== inputDob) {
      toast.error("Invalid Date of Birth");
    } else if (!matchingId && matchingId?.t1item170 === inputDob) {
      toast.error("Invalid Id");
    } else {
      toast.error("Invalid Id and Date of Birth");
    }
  };

  const handleLoginButton = () => {
    setShowPasscode(false);
    navigate("/");
  };

  return (
    <>
      <div className="">
        <div className="d-flex justify-content-center">
          <div
            className="p-4 mt-4"
            style={{
              background: "#fff",
              border: "1px solid #fff",
              borderRadius: "8px",
              boxShadow: "2px 2px 10px -1px #b9b3b3",
            }}
          >
            <p className="text-center">Enter your ID and Date of Birth</p>
            <input
              className="text-center"
              type="text"
              value={inputId}
              onChange={handleInputId}
              placeholder="Your ID"
            />
            <input
              className="text-center"
              type="text"
              value={inputDob}
              onChange={handleInputDob}
              placeholder="Your Date of Birth (MM/DD/YY)"
            />
            <div className="d-flex justify-content-center">
              <button
                className="border-0 text-center mt-4"
                onClick={handleShowPasscode}
              >
                Show Passcode
              </button>
            </div>
          </div>
        </div>
        {showPasscode && (
          <div className="text-center mt-4">
            <div>
              <p>
                Your passcode is: <strong>{matchingId?.t1key112}</strong>
              </p>
            </div>
            <div className="mt-2">
              <button className="border-0" onClick={handleLoginButton}>
                Login
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ForgotPasscode;
